import type { SecureLinkPurpose } from '@roc-capital/secure-link';

/** Purpose of the Fast Track payment secure link (the backend's SecureLinkPurpose.LOAN_FASTRACK_PAYMENT). */
export const LOAN_FASTRACK_PAYMENT_PURPOSE: SecureLinkPurpose = 'LOAN_FASTRACK_PAYMENT';

export const DOCUSIGN_CALLBACK = '/loan-fast-track-document-docusign-callback';
export const DOCUSIGN_DONE = 'loan-fast-track-document-docusign-done';
export const DOCUSIGN_INCOMPLETE = 'loan-fast-track-document-docusign-incomplete';
export const APPRAISAL_PAYMENT_LOAN = 'Appraisal_Loan';
export const APPRAISAL_PAYMENT_STANDALONE = 'Appraisal_Standalone';
export const LOAN_FASTRACK = 'Loan_Fastrack';